module.exports = __webpack_public_path__ + "static/main-variant-mobile-887bcf7d2911cf18faaa1ec7da74b8d2.webp";